import React from 'react';

export default function HomeContact() {
  return (
    <section className="contact" id="contact" aria-labelledby="contact-title">
      <div>
        <p className="eyebrow dark">Contact Us</p>
        <h2 id="contact-title" className="dh-title-2">
          Chennai-based support for audit, legal, HR and compliance work.
        </h2>
      </div>
      <div className="contact-card">
        <p>
          <strong className="contact-label">Phone</strong>
          <a href="tel:+919884211885">+91 9884211885</a>
        </p>
        <p>
          <strong className="contact-label">Email</strong>
          <a href="mailto:info@dalmaf.com">info@dalmaf.com</a>
        </p>
        <p>
          <strong className="contact-label">Office</strong>
          <span className="contact-value">T Nagar, Chennai, Tamil Nadu, 600017</span>
        </p>
      </div>
    </section>
  );
}
